import { LoaderFunction } from "@remix-run/router";
import { RouteObject } from "react-router";

export const composeLoaders =
  (...loaders: LoaderFunction[] | LoaderFunction[][]): LoaderFunction =>
  (args) =>
    Promise.all(
      loaders.flat().map((loader) => loader(args) as Promise<unknown>),
    );

export const removeRouteDescriptions = (routes: RouteObject[]): RouteObject[] =>
  routes.map((route: RouteObject) => {
    const { handle, children, ...rest } = route;
    return {
      ...rest,
      ...(handle && {
        handle: { ...handle, description: undefined },
      }),
      ...(children && { children: removeRouteDescriptions(children) }),
    };
  });
